import Bpage3 from "../../components/blog-pages/Bpage3";
import Header from "../../components/Header";
import Sobre from "../../components/Sobre";

function Page3() {
    return (
        <div>
            <Header isComunicacao={false}></Header>
            <Bpage3></Bpage3>
            <Sobre></Sobre>
        </div>
    )

}

export default Page3;